import { Gender, Organization, UserTitle } from "@main/users";
import { EditPatientInfo } from "./patient-page-item";

export interface DuplicatePatient {
    id: string;
    title: UserTitle;
    firstName: string;
    lastName: string;
    dateOfBirth: Date;
    organizations: Organization[];
    organizationGroups: string[];
    editInfo: EditPatientInfo;
    gender: Gender;
    nhsNumber?: string;
    isArchived: boolean;
    patientOnly?: boolean;
    postalCode?: string;
}

export interface DuplicatePatientCheckResult {
    matches: DuplicatePatient[];
    exactMatches: DuplicatePatient[];
    fuzzyNameMatches: DuplicatePatient[];
    exactMatchByEmail: boolean;
    exactMatchByNhsNumber: boolean;
}

export enum DuplicateCheckerType {
    CreateNewPatient = 1,
    MergePatients,
}